import './app.css';
import '@ant-design/v5-patch-for-react-19';
import { Layout } from 'antd';
import { useSelector } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import NavMenu from './components/nav-menu/nav-menu';
import Clients from './components/clients/clients';
import Auth from './components/auth/auth';
import Visits from './components/visits/visits';
import Logs from './components/logs/logs';
import Settings from './components/settings/settings';
import { Sales } from './components/sales';
import { Payments } from './components/payments';
import { Reports } from './components/reports';
import { Dialogs } from './components/dialogs';
import { Records } from './components/records';
import { Stock } from './components/stock';
import Service from './components/service/service';
import { Dashboard } from './components';
import Companies from './components/companies/companies';
import Events from './components/events/events';
import { isMobile } from './extensions/design';
import PrintPage from './controls/print-page/print-page';
import { PrintProvider } from "./extensions/print-context";
import ReportPreview from './components/settings/report-designs/report-preview';
import AppTour from './components/app-tour/app-tour';
import License from './components/license';
import { Reestrs } from './components/reestrs';

const App = () =>  {
  const user = useSelector((s) => s.user);

  const routeItem = (obj) => <div className='main-content'>
    {isMobile || <NavMenu />}
    {obj}
    {isMobile && <NavMenu />}
    <Events />
    <AppTour />
  </div>
  const router = createBrowserRouter([
    { path: "/", element: routeItem(<Dashboard />), },
    { path: "/visits", element: routeItem(<Visits />), },
    { path: "/clients", element: routeItem(<Clients />), },
    { path: "/logs", element: routeItem(<Logs />), },
    { path: "/settings/calendars", element: routeItem(<Settings page="calendars" />)},
    { path: "/settings/products", element: routeItem(<Settings page="products" />)},
    { path: "/settings/company", element: routeItem(<Settings page="company" />) }, 
    { path: "/settings/paymentvids", element: routeItem(<Settings page="paymentvids" />) }, 
    { path: "/settings/rooms", element: routeItem(<Settings page="rooms" />) }, 
    { path: "/settings/ctrls", element: routeItem(<Settings page="ctrls" />) },
    { path: "/settings/channels", element: routeItem(<Settings page="channels" />) },
    { path: "/settings/patterns", element: routeItem(<Settings page="patterns" />) },
    { path: "/settings/catalogs", element: routeItem(<Settings page="catalogs" />) },
    { path: "/settings/users", element: routeItem(<Settings page="users" />) }, 
    { path: "/settings/tokens", element: routeItem(<Settings page="tokens" />) }, 
    { path: "/settings/reports", element: routeItem(<Settings page="reports" />) }, 
    { path: "/settings/tags", element: routeItem(<Settings page="tags" />) },
    { path: "/settings", element: routeItem(<Settings page="company" />) }, 
    { path: "/sales", element: routeItem(<Sales />), },
    { path: "/payments", element: routeItem(<Payments page="payments" />), },
    { path: "/reestrs", element: routeItem(<Reestrs />), },
    { path: "/reestrs/:reestrId", element: routeItem(<Reestrs />), },
    { path: "/tickets", element: routeItem(<Payments page="tickets" />), },
    { path: "/reports", element: routeItem(<Reports />), },
    { path: "/dialogs", element: routeItem(<Dialogs />), },
    { path: "/records", element: routeItem(<Records />), },
    { path: "/stock", element: routeItem(<Stock page="stock" />), },
    { path: "/stock-osv", element: routeItem(<Stock page="stock-osv" />), },
    { path: "/stock-docs", element: routeItem(<Stock page="stock-docs" />), },
    { path: "/service", element: routeItem(<Service page="main" />), },
    { path: "/service-excel", element: routeItem(<Service page="excel" />), },
    { path: "/companies", element: routeItem(<Companies page="companies" />), },
    { path: "/message-patterns", element: routeItem(<Companies page="message-patterns" />), },
    { path: "/license/orders", element: routeItem(<License page="orders" />), },
    { path: "/license/tariffs", element: routeItem(<License page="tariffs" />), },
    { path: "/license", element: routeItem(<License page="orders" />), },
    { path: "/controls/print-page", element: routeItem(<PrintPage />), },
    { path: "/report", element: <ReportPreview />, },
  ])


  return<div>    
    {user ? <Layout style={{ minHeight: '100vh', maxWidth: '1200vw', margin: 'auto' }}>
      <PrintProvider>
        <RouterProvider router={router} notFound={<p>'Custom not found'</p>} />
      </PrintProvider>
    </Layout > : <Auth />}
  </div>
}

export default App;
